import { Button, useToast } from '@chakra-ui/react'
import { ChangeEvent, FC, useRef, useState } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import ParametroCompra from '@service/ParametroCompra'

const ActionUserUpload: FC = () => {
  const toast = useToast()
  const { getDataUsers, companieId } = useParametrizationConfigPurchase()
  const inputFileRef = useRef<HTMLInputElement>(null)
  const [isUploading, setIsUploading] = useState(false)

  const resetInput = () => {
    if (inputFileRef.current) {
      inputFileRef.current.value = ''
      inputFileRef.current.type = 'text'
      inputFileRef.current.type = 'file'
    }
  }

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file || isUploading) {
      return
    }

    setIsUploading(true)

    try {
      const formData = new FormData()
      formData.append('file', file)
      await ParametroCompra.uploadUsuarioArquivo(formData)

      toast({
        title: 'Sucesso',
        description: 'Arquivo enviado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true
      })
      // Recarrega a grade ignorando o cache, para mostrar o que foi importado
      if (companieId && getDataUsers) {
        getDataUsers(companieId, true)
      }
    } catch (error: any) {
      const message = error?.response?.data?.message || 'Erro ao enviar arquivo'
      toast({
        title: 'Erro',
        description: message,
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsUploading(false)
      // Always reset input after upload attempt (success or failure)
      setTimeout(() => {
        resetInput()
      }, 100)
    }
  }

  const onButtonClick = () => {
    // Ensure input is reset before opening file dialog
    resetInput()
    setTimeout(() => {
      inputFileRef.current?.click()
    }, 50)
  }

  return (
    <>
      <input
        type="file"
        accept=".csv"
        ref={inputFileRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <Button
        size="xs"
        fontSize="12px"
        letterSpacing=".2px"
        p="4px 6px"
        bg="gray.200"
        fontWeight="400"
        isLoading={isUploading}
        spinnerPlacement="start"
        _hover={{ bgColor: 'gray.100' }}
        _active={{ bgColor: 'gray.100' }}
        onClick={onButtonClick}
        isDisabled={isUploading}
      >
        Importar Comprador
      </Button>
    </>
  )
}

export default ActionUserUpload
